export const LOGIN_USER = "LOGIN_USER"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_MFA_SUCCESS = "LOGIN_MFA_SUCCESS"

export const LOGIN_USER_BY_CODE = "LOGIN_USER_BY_CODE"

export const LOGOUT_USER = "LOGOUT_USER"
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS"
export const API_ERROR = "LOGIN_API_ERROR"
export const RESET_ERROR_LOGIN = "RESET_ERROR_LOGIN"
